/**
 * Base call voor het ophalen van alle data.
 */

import {
	fetchDataError,
	fetchDataPending,
	fetchPageIntro,
	fetchPaginationSuccess,
	fetchTeasersSuccess,
	filterByCategory,
	filterByLocation,
	filterByValue,
	filterByRegion,
	filterBySubject,
	filterByPage,
	fetchFacetsSuccess
} from '../reducers';

export default function fetchData( page, query, categories, regions, subjects, location ) {
	return dispatch => {

		let data = {
			//"nonce": "throwaway",
			'page': page && '' !== page ? page : 1,
			'per_page': 18,
			'parameters':
				[
					{
						'name': 'query',
						'value': query,
					},
					{
						'name': 'categories',
						'value': categories,
					},
					{
						'name': 'region',
						'value': regions,
					},
					{
						'name': 'subjects',
						value: subjects
					}
				]
		};

		/**
		 * Zet actieve filters
		 */
		if ( categories && '' !== categories ) {
			dispatch( filterByCategory( categories ) );
		} else {
			dispatch( filterByCategory( '' ) );
		}

		/**
		 * Opsplitsen location array om toe tevoegen aan de array + aparte URL parameters.
		 */
		if ( location && 'undefined' !== typeof location.city && 'undefined' !== typeof location.lat && 'undefined' !== typeof location.lng ) {
			let locationData = {
				'name': 'location',
				'value': {
					'coords': location.lat + ',' + location.lng,
					'text': location.city + ', België',
					'range': 20,
				}
			};

			data.parameters.push( locationData );
			dispatch( filterByLocation( location ) );
		} else {
			dispatch( filterByLocation( {} ) );
		}

		if ( page && '' !== page ) {
			dispatch( filterByPage( page ) );
		}

		if ( query && '' !== query ) {
			dispatch( filterByValue( query ) );
		} else {
			dispatch( filterByValue( '' ) );
		}

		if ( regions && '' !== regions ) {
			let activeRegs = regions.split( ',' )
			dispatch( filterByRegion( activeRegs ) );
		} else {
			dispatch( filterByRegion( [] ) );
		}

		if ( subjects && '' !== subjects ) {
			let activeSubjects = subjects.split( ',' )
			dispatch( filterBySubject( activeSubjects ) );
		} else {
			dispatch( filterBySubject( [] ) );
		}

		/**
		 * Wachtstatus
		 */
		dispatch( fetchDataPending() );

		/**
		 * Haal data op
		 */
		fetch( '/facetsearch/json', {
			method: 'POST',
			body: JSON.stringify( data ),
		} )
			.then( result => result.json() )
			.then( result => {

				if ( result.error ) {
					throw( result.error );
				}

				/**
				 * Zorgen dat result.meta bestaat en leeg is zodat het
				 * fetchPageIntro event werkt, om ze de intro leeg te kunnen maken
				 * bij 'Alle voordelen'.
				 */
				if ( 'undefined' === typeof result.meta ) {
					result.meta = {};
					result.meta.desc = '';
					result.meta.breadcrumb = [];
				}

				/**
				 * Events momenteel apart gedispatcht om makkelijker overzicht te behouden,
				 * kunnen wel gereduceerd worden naar "fetchData" o.i.d.
				 */
				dispatch( fetchPaginationSuccess( result.total, result.page, result.pages ) );
				dispatch( fetchTeasersSuccess( result.results ) );
				dispatch( fetchPageIntro( result.meta.desc ) );

				/**
				 * Facets moeten ook hier opgehaald worden om de aantallen aan te passen als er items geselecteerd worden
				 */
				dispatch( fetchFacetsSuccess( result.filters ) );

				return result.results;
			} )
			.catch( error => {
				dispatch( fetchDataError( error ) );
			} );
	}
}
